import { get, post } from '@/utils/request';

export const top_projects = (params) => {
  return get('/api/v1/top_projects', params);
};

export const projects_byindex = (params) => {
  return get('/api/v1/projects_byindex', params);
};
export const projectbyid = (id) => {
  return get(`/api/v1/project/${id}`);
};

export const project_locs = (params) => {
  return get(`/api/v1/project_locs`, params);
};

export const projectSave = (params) => {
  return post(`/api/v1/project`, params);
};
